var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 15,
    viewBox: "0 0 24 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.498 7.4999H7.35802C7.45303 7.17491 7.503 6.8399 7.49803 6.49991C7.49803 5.29992 5.99302 4.4999 4.99805 4.4999H1.99806C1.64804 4.4999 1.30304 4.59989 0.998076 4.77989V0.999893C0.998076 0.724877 0.773077 0.499878 0.498062 0.499878C0.223046 0.499925 -0.00195312 0.724924 -0.00195312 0.999893V13.9999C-0.00195312 14.2749 0.223046 14.4999 0.498062 14.4999C0.773077 14.4999 0.998076 14.2749 0.998076 13.9999V11.4999H22.998V13.4999C22.998 13.7749 23.223 13.9999 23.498 13.9999C23.773 13.9999 23.998 13.7749 23.998 13.4999V7.99991C23.998 7.7249 23.773 7.4999 23.498 7.4999ZM1.99806 5.49988H4.99805C5.60307 5.49988 6.49805 6.02488 6.49805 6.49987C6.49805 7.4999 6.21802 7.4999 5.99804 7.4999H1.99806C1.44808 7.4999 0.998076 7.0499 0.998076 6.49991C0.998076 5.94993 1.44803 5.49988 1.99806 5.49988ZM22.998 10.4999H0.998029V8.49988H22.998V10.4999H22.998Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedIcon);
export default __webpack_public_path__ + "static/media/bedIcon.177b69803e20550a99a8e69365b78846.svg";
export { ForwardRef as ReactComponent };